// Builds a fresh game in the `attract` phase, seeded for determinism.

import type { GameState, Cities, Bases } from './types';
import { makeSeed } from '../rng/mulberry32';
import {
  AMMO_PER_BASE,
  BASE_POSITIONS,
  CITY_POSITIONS,
  multiplierForWave,
} from '../constants';

export function createInitialState(seed: number): GameState {
  const cities: Cities = [
    { id: 0, pos: CITY_POSITIONS[0], alive: true },
    { id: 1, pos: CITY_POSITIONS[1], alive: true },
    { id: 2, pos: CITY_POSITIONS[2], alive: true },
    { id: 3, pos: CITY_POSITIONS[3], alive: true },
    { id: 4, pos: CITY_POSITIONS[4], alive: true },
    { id: 5, pos: CITY_POSITIONS[5], alive: true },
  ];

  const bases: Bases = [
    { id: 0, pos: BASE_POSITIONS[0], ammo: AMMO_PER_BASE, alive: true },
    { id: 1, pos: BASE_POSITIONS[1], ammo: AMMO_PER_BASE, alive: true },
    { id: 2, pos: BASE_POSITIONS[2], ammo: AMMO_PER_BASE, alive: true },
  ];

  return {
    phase: { kind: 'attract' },
    wave: 1,
    score: 0,
    scoreMultiplier: multiplierForWave(1),
    bonusCityProgress: 0,
    reserveCities: 0,
    cities,
    bases,
    enemyMissiles: [],
    playerMissiles: [],
    explosions: [],
    flyingObjects: [],
    spawnQueue: [],
    flyingSpawnAt: null,
    waveTimer: 0,
    pendingKills: [],
    rng: makeSeed(seed),
    nextEntityId: 1,
  };
}
